export function ShowFadeRightLeftSection(nomeClasse, startTime = .2, callBackOnEnd = null) {//aqui é para a animação de quando ve a seção pos-vantagens
    if (!nomeClasse) { return }
    const target = document.querySelector(`.${nomeClasse}`);
    const targetClass = document.getElementsByClassName(`${nomeClasse}`);
    for (let i = 0; i < targetClass.length; i++) {
        targetClass[i].style.opacity = '0';
    }
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('ShowFadeRightLeftSection');
                observer.unobserve(entry.target); // Remove o observador após a primeira exibição
                callBackOnEnd?.();
            }
        });
    }, {
        threshold: 0.8 // 80% da seção visível já ativa a animação
    });

    if (target) {

        setTimeout(() => {
            observer.observe(target)
        }, startTime * 1000);
    }
}